const IS_PROD = process.env.REACT_APP_CLIENT_ENV === 'production';
const BASE_URL = `${process.env.REACT_APP_CEREBRAL_PLATFORM_URL ?? ''}`;

export const ASSET_BASE_URL = 'https://media.cerebral.com/clientStatic';
export const AVAILABILITY_BASE_PATH = `${BASE_URL}/api/v1/clinician-availability`;
export const CLINICIAN_MATCHING_BASE_PATH = `${BASE_URL}/api/clinician-matching-service`;
export const PROFILE_PHOTO_BASE_PATH = IS_PROD
  ? 'https://media.cerebral.com/ProductionProfilePhotos'
  : 'https://media.cerebral-development.com/StagingProfilePhotos';
export const HOMEPAGE_URL = IS_PROD ? 'https://cerebral.com' : 'https://home.cerebral-development.com';

export const PARTNER_INTEGRATION_BASE_PATH = `${BASE_URL}/api/v1/partner-integration-service`;
